<template>
    <div class="d-flex flex-column gap-5 side-nav-padding">
        <div>
            <p class="fs-5 fw-600 mb-1 text-muted">{{$trans('storefront::image_editor.size')}}</p>
            <div class="d-flex flex-wrap gap-4">
                <div class="image-editor-card-primary cursor-pointer flex-grow-1 cutline-card" :class="{'selected' : store.mask_type === 'die_cut_small'}" @click="setMaskType($event)" data-value="die_cut_small">
                    <img :src="$getImg('icons/expand-icon@2x.png')" class="card-icon mb-2">
                    <p class="fs-5">{{$trans('storefront::image_editor.small')}}</p>
                </div>

                <div class="image-editor-card-primary cursor-pointer flex-grow-1 cutline-card" :class="{'selected' : store.mask_type === 'die_cut_medium'}" @click="setMaskType($event)" data-value="die_cut_medium">
                    <img :src="$getImg('icons/expand-icon@2x.png')" class="card-icon mb-2">
                    <p class="fs-5">{{$trans('storefront::image_editor.medium')}}</p>
                </div>

                <div class="image-editor-card-primary cursor-pointer flex-grow-1 cutline-card" :class="{'selected' : store.mask_type === 'die_cut_custom'}" @click="setMaskType($event)" data-value="die_cut_custom">
                    <img :src="$getImg('icons/expand-icon@2x.png')" class="card-icon mb-2">
                    <p class="fs-5">{{$trans('storefront::image_editor.custom')}}</p>
                </div>
            </div>
        </div>

        <div v-show="store.mask_type === 'die_cut_custom'">
            <p class="fs-5 fw-600 text-muted">{{$trans('storefront::image_editor.stroke_width')}}</p>

            <div class="d-flex gap-4">
                <range-slider :min="8" :max="50" style="max-width: 244px" v-model="store.maskData.die_cut_custom.stroke_width" @input="debouncedInput"></range-slider>

                <div class="fw-500">
                    {{store.maskData.die_cut_custom.stroke_width}}px
                </div>
            </div>
        </div>

        <div>
            <p class="fs-5 fw-600 mb-1 text-muted">{{$trans('storefront::image_editor.shape')}}</p>

            <div class="d-flex flex-wrap gap-4">
                <div class="image-editor-card-primary cursor-pointer flex-grow-1 cutline-card" :class="{'selected' : store.mask_type === 'square'}" @click="setMaskType($event)" data-value="square">
                    <img :src="$getImg('icons/square-icon@2x.png')" class="card-icon mb-2">
                    <p class="fs-5">{{$trans('storefront::image_editor.square')}}</p>
                </div>

                <div class="image-editor-card-primary cursor-pointer flex-grow-1 cutline-card" :class="{'selected' : store.mask_type === 'circle'}" @click="setMaskType($event)" data-value="circle">
                    <img :src="$getImg('icons/circle-icon@2x.png')" class="card-icon mb-2">
                    <p class="fs-5">{{$trans('storefront::image_editor.circle')}}</p>
                </div>

                <div class="image-editor-card-primary cursor-pointer flex-grow-1 cutline-card" :class="{'selected' : store.mask_type === 'rounded_corners'}" @click="setMaskType($event)" data-value="rounded_corners">
                    <img :src="$getImg('icons/rounded-corners-icon@2x.png')" class="card-icon mb-2">
                    <p class="fs-5">{{$trans('storefront::image_editor.rounded_corners')}}</p>
                </div>
            </div>
        </div>

        <div v-show="store.mask_type === 'rounded_corners'">
            <p class="fs-5 fw-600 text-muted">{{$trans('storefront::image_editor.radius')}}</p>

            <div class="d-flex gap-4">
                <range-slider :min="0" :max="50" style="max-width: 244px" v-model="store.maskData.rounded_corners.radius" @input="onRadiusChange"></range-slider>

                <div class="fw-500">
                    {{store.maskData.rounded_corners.radius*2}}%
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useImageEditorStore } from '../store';
import {functions} from "../imageEditor";
import debounce from 'lodash/debounce';


export default {
    setup() {
        const store = useImageEditorStore();

        return {
            store: store,
        }
    },
    created() {
        this.debouncedInput = debounce(()=> {
            functions.updateMask();
        }, 500);
    },
    methods: {
        setMaskType (event) {
            let value = event.target.closest('.cutline-card').getAttribute('data-value');
            this.store.mask_type = value;

            functions.updateMask();
        },
        onRadiusChange() {
            functions.updateMask();
        }
    }
}
</script>

<style lang="scss" scoped>
    .cutline-card {
        user-select: none;
    }
</style>
